import React, { ReactNode } from 'react';
import { Input } from 'src/components/ui';
import Field, { describedById } from './Field';
import { FieldWidth } from './types';

export type TextFieldProps = {
  id: string;
  label: ReactNode;
  value: string | null | undefined;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'tel' | 'password';
  required?: boolean;
  error?: string;
  help?: ReactNode;
  width?: FieldWidth;
  readOnly?: boolean;
  autoComplete?: string;
  placeholder?: string;
};

export function TextField({
  id,
  label,
  value,
  onChange,
  type = 'text',
  required,
  error,
  help,
  width,
  readOnly,
  autoComplete,
  placeholder,
}: TextFieldProps) {
  return (
    <Field label={label} htmlFor={id} required={required} help={help} error={error} width={width}>
      <Input
        id={id}
        type={type}
        value={value ?? ''}
        readOnly={readOnly}
        autoComplete={autoComplete}
        placeholder={placeholder}
        // Grows with what is typed; size=1 drops the browser's default width where field-sizing is unsupported,
        // so the field falls back to its token minimum.
        className="field-sizing-content"
        size={1}
        invalid={!!error}
        aria-required={required}
        aria-invalid={!!error}
        aria-describedby={describedById(id, error, help)}
        onChange={e => onChange(e.target.value)}
      />
    </Field>
  );
}

export default TextField;
